import React, { useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useEffect } from "react";

import Nav from "./components/nav/Nav";
import Home from "./components/home/Home";
import Blog from "./components/blog/Blog";
import Storage from "./components/storage/Storage";
import PrivateStorage from "./components/storage/PrivateStorage";
import OnlineStorage from "./components/storage/OnlineStorage";
import GetBack from "./components/storage/GetBack";
import BusinessStorage from "./components/storage/BusinessStorage";
import StorageSummary from "./components/storage/StorageSummary";
import StoragePay from "./components/storage/StoragePay";
import Transport from "./components/transport/Transport";
import TransportFewItems from "./components/transport/TransportFewItems";
import TransportApartment from "./components/transport/TransportApartment";
import TransportGetBack from "./components/transport/TransportGetBack";
import TransportOnlineAddress from "./components/transport/TransportOnlineAddress";
import TransportOnlineItems from "./components/transport/TransportOnlineItems";
import TransportOffice from "./components/transport/TransportOffice";
import TransportSummary from "./components/transport/TransportSummary";
import { getContent, getPopups } from "./redux/actions-exporter";
import mainLogo from "./assets/images/aviLogo.jpeg";
import PostFull from "./components/blog/PostFull";
import Popup from "./components/popup/Popup";

import "./App.css";
import WhatsappButton from "./components/WhatsappButton/index";

function App() {
  const [isMoving, setIsMoving] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getPopups());
    dispatch(getContent());
  }, [dispatch]);
  return (
    <BrowserRouter>
      {/* <WhatsappButton /> */}
      {/* <Nav /> */}
      {/* <Popup /> */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:id" element={<PostFull />} />
        <Route path="/storage" element={<Storage />} />
        <Route path="/privatestorage" element={<PrivateStorage />} />
        <Route
          path="/onlinestorage"
          element={
            <OnlineStorage
              mainLogo={mainLogo}
              isMoving={isMoving}
              setIsMoving={setIsMoving}
            />
          }
        />
        <Route
          path="/getbackstorage"
          element={<GetBack mainLogo={mainLogo} />}
        />
        <Route
          path="/businessStorage"
          element={<BusinessStorage mainLogo={mainLogo} />}
        />
        <Route
          path="/storageSummary"
          element={<StorageSummary mainLogo={mainLogo} isMoving={isMoving} />}
        />
        <Route
          path="/storagepay"
          element={<StoragePay mainLogo={mainLogo} />}
        />

        <Route path="/transport" element={<Transport />} />
        <Route
          path="/transportfewitems"
          element={<TransportFewItems mainLogo={mainLogo} />}
        />
        <Route path="/transportapartment" element={<TransportApartment />} />
        <Route
          path="/transportgetback"
          element={<TransportGetBack mainLogo={mainLogo} />}
        />
        <Route
          path="/transportonlineaddress"
          element={<TransportOnlineAddress mainLogo={mainLogo} />}
        />
        <Route
          path="/transportonlineitems"
          element={<TransportOnlineItems mainLogo={mainLogo} />}
        />
        <Route
          path="/transportoffice"
          element={<TransportOffice mainLogo={mainLogo} />}
        />
        <Route
          path="/transportsummary"
          element={<TransportSummary mainLogo={mainLogo} />}
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
